import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportTypeApi } from 'api-typings/support/support';
import type { PreferredSupportAgentAssignment } from './preferred-support-agent.model';

export interface GeneratePreferredSupportAgentAssignment {
  readonly id?: number;
  readonly userId: number;
  readonly agentId: number;
  readonly supportType: SupportTypeApi;
  readonly username?: string;
  readonly agentUsername?: string;
  readonly assignedAt?: number;
  readonly removedAt?: number;
}

/**
 * Create a PreferredSupportAgentAssignment object
 */
export function generatePreferredSupportAgentAssignmentObject({
  id = generateId(),
  userId,
  agentId,
  supportType,
  username,
  agentUsername,
  assignedAt = Date.now() * 1000,
  removedAt,
}: GeneratePreferredSupportAgentAssignment): PreferredSupportAgentAssignment {
  return {
    id,
    userId,
    agentId,
    supportType,
    username,
    agentUsername,
    assignedAt,
    removedAt,
  };
}
